'use strict';

exports.__esModule = true;
exports['default'] = mountGlobalStyles;
var css = '\n  html, body {\n    margin: 0;\n    padding: 0;\n  }\n  html, body, #app {\n    height: 100%;\n  }\n';

function mountGlobalStyles() {
  var style = document.createElement('style');
  style.type = 'text/css';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  document.head.appendChild(style);
}

module.exports = exports['default'];